import { render, staticRenderFns } from "./GenericMedia.vue?vue&type=template&id=1972cfc5&scoped=true"
import script from "./GenericMedia.vue?vue&type=script&lang=js"
export * from "./GenericMedia.vue?vue&type=script&lang=js"
import style0 from "./GenericMedia.vue?vue&type=style&index=0&id=1972cfc5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1972cfc5",
  null
  
)

export default component.exports